import { apiClient } from "api/apiClient";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDealershipDetails } from "store/actions";
import { COLORS, SIZES, WEIGHT } from "theme";
import { ERROR_CODES, generateUid, getCityOfState, getStates } from "utils";
import "./dealership-form.css";
import Text from "ReusableComponents/Text";

import Button from "ReusableComponents/Button";

const DealershipForm = ({ getAction, small,state,setState }) => {
  const { states, cities } = useSelector((state) => state.Landing);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [cityOptions, setCityOptions] = useState([]);


  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value === "None") return;
    setState({
      ...state,
      [name]: value,
    });
  };

  useEffect(() => {
    const utm_medium = sessionStorage.getItem("utm_medium");
    const utm_source = sessionStorage.getItem("utm_source");
    const utm_campaign = sessionStorage.getItem("utm_campaign");
    const gclid = sessionStorage.getItem("gclid");

    if (utm_medium || utm_source || utm_campaign) {
      setState({ ...state, utm_medium, utm_source, utm_campaign, gclid });
    }

    if (state.stateAppliedFor) {
      const filterCities = cities.filter(
        (item) =>
          state.stateAppliedFor ===
          item?.attributes?.linked_state?.data?.attributes?.state_name
      );

      setCityOptions(filterCities);
    }
    // window.onbeforeunload = function () {
    //   const data = {
    //     uuid: generateUid(),
    //     data: state,
    //     form_name: "Dealership",
    //     utm_source: utm_source,
    //     utm_medium: utm_medium,
    //     utm_campaign: utm_campaign,
    //     gclid: gclid,
    //   };
    //   apiClient.submitDealership(data);
    //   return "Are you sure you want to leave this page?";
    // };
  }, [state.stateAppliedFor, state]);

  const checkFormValid = () => {
    if (
      state.dealershipName &&
      state.firstName &&
      state.lastName &&
      state.email &&
      state.phone &&
      state.dob &&
      state.educationalQualification &&
      state.street &&
      state.pincode &&
      state.city &&
      state.state &&
      state.country &&
      state.partnership &&
      state.stateAppliedFor &&
      state.cityAppliedFor &&
      state.currentBusinessDetails &&
      state.industryExperience &&
      state.yearsOfExperience &&
      state.companiesPartneredWith &&
      state.annualTurnover &&
      state.landDetail &&
      state.additionalComments &&
      state.approaxAmountToInvest &&
      state.communicationConsent
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault()
    if (checkFormValid()) {
      setLoading(true);
      setError(false);
      // state["application_id"] = generateUid();
      // state["application_id"] = state["application_id"].toString();

      apiClient
        .submitDealerOnBoard(state)
        .then((res) => {
          dispatch(getDealershipDetails(res?.message));
          getAction("submit");
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setLoading(false));
    } else {
      setError(ERROR_CODES.empty);
    }
  };

  return (
    <div
      class="form_container"
      style={{ justifyContent: "center", padding: small && "20px" }}
    >
      <div class="form_heading">Submit Your Application Form Below</div>
      <div class="form_subtext">
        All that you need to do is to fill up a simple form online and we shall
        get back to you!
      </div>
      <div className="form_container">
        <form action="#" onSubmit={handleSubmit}>
          <h3 class="form_section_heading">Personal Information</h3>

          {/* <div class="form-row">
            <div class="form_field">
              <label class="field_label">
                Salutation <span class="mandatory">*</span>
              </label>
              <div class="radio_container">
                <div>
                  <input
                    class="radio_box"
                    type="radio"
                    name="prefix"
                    value="Mr."
                    id="prefix_mr"
                    onChange={handleChange}
                  />
                  <label class="radio_label" for="prefix_mr">
                    Mr.
                  </label>
                </div>

                <div>
                  <input
                    class="radio_box"
                    type="radio"
                    name="prefix"
                    value="Ms."
                    id="prefix_ms"
                    onChange={handleChange}
                  />
                  <label class="radio_label" for="prefix_ms">
                    Ms.
                  </label>
                </div>

                <div>
                  <input
                    class="radio_box"
                    type="radio"
                    name="prefix"
                    value="Mrs."
                    id="prefix_mrs"
                    onChange={handleChange}
                  />
                  <label class="radio_label" for="prefix_mrs">
                    Mrs.
                  </label>
                </div>
              </div>
            </div>
          </div> */}



          <div class="form_field" style={{marginBottom:"2rem"}}>
            <label class="field_label" for="first_name_field">
              Dealership Name <span class="mandatory">*</span>
            </label>
            <input
              class="input_box"
              type="text"
              name="dealershipName"
              placeholder="Enter Dealership Name"
              id="dealershipName_field"
              required
              value={state.dealershipName}
              onChange={handleChange}
              style={{width:"100%"}}
            />
          </div>

          <div class="form-row">
            <div class="form_field">
              <label class="field_label" for="first_name_field">
                First Name <span class="mandatory">*</span>
              </label>
              <input
                class="input_box"
                type="text"
                name="firstName"
                placeholder="Enter First Name"
                id="first_name_field"
                required
                value={state.firstName}
                onChange={handleChange}
              />
            </div>

            <div class="form_field">
              <label class="field_label" for="last_name_field">
                Last Name <span class="mandatory">*</span>
              </label>
              <input
                class="input_box"
                type="text"
                name="lastName"
                placeholder="Enter Last Name"
                id="last_name_field"
                required
                value={state.lastName}
                onChange={handleChange}
              />
            </div>

            <div class="form_field">
              <label class="field_label" for="email_field">
                Email <span class="mandatory">*</span>
              </label>
              <input
                class="input_box"
                type="email"
                name="email"
                placeholder="Enter Email Address"
                id="email_field"
                required
                value={state.email}
                onChange={handleChange}
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form_field">
              <label class="field_label" for="phone_field">
                Phone Number <span class="mandatory">*</span>
              </label>
              <input
                class="input_box"
                type="number"
                name="phone"
                placeholder="Enter Phone Number"
                id="phone_field"
                required
                value={state.phone}
                onChange={handleChange}
              />
            </div>
            <div class="form_field">
              <label class="field_label" for="dob_field">
                Date of Birth <span class="mandatory">*</span>
              </label>
              <input
                class="input_box"
                type="date"
                name="dob"
                id="dob_field"
                required
                value={state.dob}
                onChange={handleChange}
              />
            </div>
            <div class="form_field">
              <label class="field_label" for="educationalQualification_field">
                Educational Qualification{" "}
              </label>
              <input
                class="input_box"
                type="text"
                name="educationalQualification"
                placeholder="Enter Education Qualification"
                id="educationalQualification_field"
                value={state.educationalQualification}
                onChange={handleChange}
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form_field">
              <label class="field_label" for="personal_address_field">
                Street<span class="mandatory">*</span>
              </label>
              <textarea
                class="input_box input_box_m"
                name="street"
                placeholder="Street"
                id="street_field"
                value={state.street}
                onChange={handleChange}
              ></textarea>
            </div>
          </div>

          <div class="form-row">
            <div class="form_field">
              <label class="field_label" for="state_field">
                State <span class="mandatory">*</span>
              </label>
              <select
                className="input_box"
                onChange={handleChange}
                name="state"
                required
              >
                <option value="None" selected>
                  Select State
                </option>
                {getStates().map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              <i
                className="arrow down"
                style={{
                  position: "absolute",
                  top: "0px",
                  right: "10px",
                }}
              ></i>
            </div>
            <div class="form_field">
              <label class="field_label" for="city_field">
                City <span class="mandatory">*</span>
              </label>
              <select
                style={{
                  background: "white",
                }}
                value={state.bu}
                className="input_box"
                onChange={handleChange}
                name="city"
                required
              >
                <option value="None" selected>
                  Select City
                </option>

                {state.state &&
                  getCityOfState(state.state).map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
              </select>
            </div>
            <div class="form_field">
              <label class="field_label" for="pincode_field">
                Pincode <span class="mandatory">*</span>
              </label>
              <input
                class="input_box"
                type="number"
                name="pincode"
                placeholder="Enter Pincode"
                id="pincode_field"
                required
                value={state.pincode}
                onChange={handleChange}
              />
            </div>
          </div>

          <h3 class="form_section_heading">Business Information</h3>

          <div class="form-row">
            <div class="form_field">
              <label class="field_label">
                Partnership <span class="mandatory">*</span>
              </label>
              <div class="radio_container">
                <div>
                  <input
                    class="radio_box"
                    type="radio"
                    name="partnership"
                    value="Dealership"
                    id="type_dealership"
                    onChange={handleChange}
                  />

                  <label class="radio_label" for="type_dealership">
                    Dealership
                  </label>
                </div>
                <div>
                  <input
                    class="radio_box"
                    type="radio"
                    name="partnership"
                    value="Authorized Service Center"
                    id="type_service_center"
                    onChange={handleChange}
                  />
                  <label class="radio_label" for="type_service_center">
                    Authorized Service Center
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form_field">
              <label class="field_label" for="business_state_field">
                State Applied For <span class="mandatory">*</span>
              </label>
              <select
                value={state.stateAppliedFor}
                name="stateAppliedFor"
                onChange={handleChange}
                className="input_box"
              >
                <option value="None" selected>
                  Select State
                </option>

                {getStates().map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              <i
                className="arrow down"
                style={{
                  position: "absolute",
                  top: "15px",
                  right: SIZES.twentyFour,
                }}
              ></i>
            </div>
            <div class="form_field">
              <label class="field_label" for="business_city_field">
                City Applied For <span class="mandatory">*</span>
              </label>
              <select
                value={state.cityAppliedFor}
                onChange={handleChange}
                class="input_box"
                type="text"
                name="cityAppliedFor"
                id="business_city_field"
                required
              >
                <option value="None" selected>
                  Select City
                </option>

                {state.stateAppliedFor &&
                  getCityOfState(state.stateAppliedFor).map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div class="form-row">
            <div class="form_field">
              <label class="field_label" for="currentBusinessDetails">
                Current Business Details <span class="mandatory">*</span>
              </label>
              <textarea
                class="input_box input_box_m"
                name="currentBusinessDetails"
                placeholder="Enter Current Business Details"
                id="currentBusinessDetails"
                value={state.currentBusinessDetails}
                onChange={handleChange}
              ></textarea>
            </div>
            <div class="form_field">
              <label class="field_label" for="industryExperience">
                Automotive industry experience <span class="mandatory">*</span>
              </label>
              <textarea
                class="input_box input_box_m"
                name="industryExperience"
                placeholder="Enter Automotive Industry Experience"
                id="industryExperience"
                value={state.industryExperience}
                onChange={handleChange}
              ></textarea>
            </div>
          </div>

          <div class="form-row">
            <div class="form_field">
              <label class="field_label" for="yearsOfExperience">
                Number of years in business<span class="mandatory">*</span>
              </label>
              <input
                class="input_box"
                type="number"
                name="yearsOfExperience"
                placeholder="Enter Years in numbers"
                id="yearsOfExperience_field"
                value={state.yearsOfExperience}
                onChange={handleChange}
              />
            </div>
            <div class="form_field">
              <label class="field_label" for="companiesPartneredWith">
                Which companies have you partnered with?
                <span class="mandatory">*</span>
              </label>
              <input
                class="input_box"
                type="text"
                name="companiesPartneredWith"
                placeholder="Enter Company Names"
                id="companiesPartneredWith_field"
                value={state.companiesPartneredWith}
                onChange={handleChange}
              />
            </div>
            <div class="form_field">
              <label class="field_label" for="annualTurnover">
                Annual turnover of your business (In lakhs)
                <span class="mandatory">*</span>
              </label>
              <input
                class="input_box"
                type="number"
                name="annualTurnover"
                placeholder="Enter Turnover in lakhs*"
                id="annualTurnover_field"
                value={state.annualTurnover}
                onChange={handleChange}
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form_field">
              <label class="field_label">
                Land Details <span class="mandatory">*</span>
              </label>
              <div class="radio_container">
                <div>
                  <input
                    class="radio_box"
                    type="radio"
                    name="landDetail"
                    value="Owned"
                    id="land_owned"
                    onChange={handleChange}
                  />
                  <label class="radio_label" for="land_owned">
                    Owned
                  </label>
                </div>
                <div>
                  <input
                    class="radio_box"
                    type="radio"
                    name="landDetail"
                    value="Rented"
                    id="land_rented"
                    onChange={handleChange}
                  />
                  <label class="radio_label" for="land_rented">
                    Rented
                  </label>
                </div>

                <div>
                  <input
                    class="radio_box"
                    type="radio"
                    name="landDetail"
                    value="Others"
                    id="land_other"
                    onChange={handleChange}
                  />
                  <label class="radio_label" for="land_other">
                    Others
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form_field">
              <label class="field_label" for="additionalComments_field">
                Comments
              </label>
              <textarea
                class="input_box input_box_m"
                name="additionalComments"
                placeholder="Enter any additional comments"
                id="additionalComments_field"
                value={state.additionalComments}
                onChange={handleChange}
              ></textarea>
            </div>
          </div>

          <div class="form-row">
            <div class="form_field">
              <label class="field_label">
                What is the approximate amount you are willing to invest? (In
                Rupees) <span class="mandatory">*</span>
              </label>
              <div class="radio_container">
                <div>
                  <input
                    class="radio_box"
                    type="radio"
                    name="approaxAmountToInvest"
                    value="30 to 50 Lakhs"
                    id="3_5_l"
                    onChange={handleChange}
                  />
                  <label class="radio_label" for="3_5_l">
                    30 to 50 Lakhs
                  </label>
                </div>

                <div>
                  <input
                    class="radio_box"
                    type="radio"
                    name="approaxAmountToInvest"
                    value="50 Lakhs to 1 Crore"
                    id="50_l_1_c"
                    onChange={handleChange}
                  />
                  <label class="radio_label" for="50_l_1_c">
                    50 Lakhs to 1 Crore
                  </label>
                </div>

                <div>
                  <input
                    class="radio_box"
                    type="radio"
                    name="approaxAmountToInvest"
                    value="1 to 3 Crore"
                    id="1_c_3_c"
                    onChange={handleChange}
                  />
                  <label class="radio_label" for="1_c_3_c">
                    1 to 3 Crore
                  </label>
                </div>

                <div>
                  <input
                    class="radio_box"
                    type="radio"
                    name="approaxAmountToInvest"
                    value="3 to 5 Crore"
                    id="3_c_5_c"
                    onChange={handleChange}
                  />
                  <label class="radio_label" for="3_c_5_c">
                    3 to 5 Crore
                  </label>
                </div>
                <div>
                  <input
                    class="radio_box"
                    type="radio"
                    name="approaxAmountToInvest"
                    value="5 Crore and above"
                    id="mt_5_c"
                    onChange={handleChange}
                  />
                  <label class="radio_label" for="mt_5_c">
                    5 Crore and above
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="radio_container">
              <div>
                <input
                  class="radio_box"
                  type="radio"
                  name="communicationConsent"
                  value="Yes"
                  id="authorized"
                  required
                  onChange={handleChange}
                />
                <label class="radio_label" for="authorized">
                  <span class="mandatory">*</span> I authorise Euler Motors to
                  contact me via SMS, Email, Whatsapp and other modes of
                  communication.
                </label>
              </div>
            </div>
          </div>

          <div class="form-row">
            <Button
              display="flex"
              w="218px"
              cursor={loading ? "not-allowed" : "pointer"}
              pointerEvents={loading ? "none" : "auto"}
              opacity={loading ? 0.5 : 1}
              hoverBackground={true}
              justifyContent="center"
              background={hover ? COLORS.black : COLORS.primary}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              // onClick={handleSubmit}
            >
              <Text
                fontSize={small ? SIZES.twelve : "16px"}
                fontWeight="bold"
                textColor={hover ? COLORS.white : COLORS.black}
              >
                Take The Next Step
              </Text>
            </Button>
            {error && (
              <p style={{ color: "red", fontWeight: WEIGHT.bold }}>{error}</p>
            )}
          </div>

          <div class="form-row">
            <div class="contact_info">
              Need More Details? Reach out to us at{" "}
              <a href="tel:1800 1238 1238">1800 1238 1238</a>.
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DealershipForm;
